// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__PCZnJ","form-title":"Common_form-title__oFNPG","form-actions":"Common_form-actions__VVU0v"};